import { createContext, useContext, useMemo, type ReactNode } from 'react'
import { authStatus, readAuthConfig, type AuthStatus, type ConsumerAuthConfig } from './authConfig'

interface AuthContextValue {
  status: AuthStatus
  config: ConsumerAuthConfig | null
}

const AuthContext = createContext<AuthContextValue>({
  status: 'not-configured',
  config: null,
})

export function AuthProvider({ children }: { children: ReactNode }) {
  const value = useMemo(() => {
    const config = readAuthConfig()
    return { status: authStatus(config), config }
  }, [])
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAuth() {
  return useContext(AuthContext)
}
